/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SwapScreenerLeadResidents200ResponseDataLead1
 */
export interface SwapScreenerLeadResidents200ResponseDataLead1 {
    /**
     * 
     * @type {string}
     * @memberof SwapScreenerLeadResidents200ResponseDataLead1
     */
    lead_id?: string;
    /**
     * 
     * @type {string}
     * @memberof SwapScreenerLeadResidents200ResponseDataLead1
     */
    new_bed_id?: string;
}

/**
 * Check if a given object implements the SwapScreenerLeadResidents200ResponseDataLead1 interface.
 */
export function instanceOfSwapScreenerLeadResidents200ResponseDataLead1(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SwapScreenerLeadResidents200ResponseDataLead1FromJSON(json: any): SwapScreenerLeadResidents200ResponseDataLead1 {
    return SwapScreenerLeadResidents200ResponseDataLead1FromJSONTyped(json, false);
}

export function SwapScreenerLeadResidents200ResponseDataLead1FromJSONTyped(json: any, ignoreDiscriminator: boolean): SwapScreenerLeadResidents200ResponseDataLead1 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lead_id': !exists(json, 'lead_id') ? undefined : json['lead_id'],
        'new_bed_id': !exists(json, 'new_bed_id') ? undefined : json['new_bed_id'],
    };
}

export function SwapScreenerLeadResidents200ResponseDataLead1ToJSON(value?: SwapScreenerLeadResidents200ResponseDataLead1 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lead_id': value.lead_id,
        'new_bed_id': value.new_bed_id,
    };
}

